import m from "./index.es417.js";
import i from "./index.es418.js";
import g from "./index.es144.js";
const C = (t, e, n = 3) => {
  let a = 0;
  const p = m(50, 250);
  return i((s) => {
    const r = s.loaded, o = s.lengthComputable ? s.total : void 0, d = r - a, l = p(d), u = r <= o;
    a = r;
    const c = {
      loaded: r,
      total: o,
      progress: o ? r / o : void 0,
      bytes: d,
      rate: l || void 0,
      estimated: l && o && u ? (o - r) / l : void 0,
      event: s,
      lengthComputable: o != null,
      [e ? "download" : "upload"]: !0
    };
    t(c);
  }, n);
}, h = (t, e) => {
  const n = t != null;
  return [(a) => e[0]({
    lengthComputable: n,
    total: t,
    loaded: a
  }), e[1]];
}, y = (t) => (...e) => g.asap(() => t(...e));
export {
  y as asyncDecorator,
  h as progressEventDecorator,
  C as progressEventReducer
};
//# sourceMappingURL=index.es356.js.map
